<template>
  <div class="overflow-hidden w-full translate-z-0 relative">
    <MImage
      class="absolute w-full h-full top-0 left-0"
      :class="[
        imageClass,
        {
          'object-cover': size === 'cover',
          'object-contain': size === 'contain',
        },
      ]"
      :src="src"
      :low-src="lowSrc"
      :srcset="srcset"
      :lazy="lazy"
      :alt="alt"
    />
    <ImageCopyright v-if="copyright" :copyright="copyright" />
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    src: string
    lowSrc?: string | null
    srcset?: string
    lazy?: boolean
    size?: 'cover' | 'contain'
    imageClass?: string | object
    alt?: string
    copyright?: string | null
  }>(),
  { lazy: true, size: 'cover' },
)
</script>
